import { useQuery } from "@tanstack/react-query";
import { getReturnWidgetBaseUrl } from "./return-widget-client";

export type ExchangeSuggestionItem = {
  variantId: string;
  title: string;
  sizeLabel: string;
  imageUrl: string | null;
  isInStock: boolean;
  direction: "above" | "below";
};

export type ExchangeReason = "SIZE_TOO_LARGE" | "SIZE_TOO_SMALL";

export function useExchangeSuggestions(
  shopId: string,
  productId: string | null | undefined,
  currentVariantId: string | null | undefined,
  reason: ExchangeReason | null | undefined,
) {
  return useQuery<ExchangeSuggestionItem[]>({
    queryKey: ["exchange-suggestions", shopId, productId, currentVariantId, reason],
    queryFn: async () => {
      const base = getReturnWidgetBaseUrl().replace(/\/$/, "");
      const url = new URL(`${base}/public/sizing/exchange-suggestions`);
      url.searchParams.set("shopId", shopId);
      url.searchParams.set("productId", productId!);
      url.searchParams.set("currentVariantId", currentVariantId!);
      url.searchParams.set("reason", reason!);
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error(`exchange-suggestions ${res.status}`);
      return res.json() as Promise<ExchangeSuggestionItem[]>;
    },
    enabled: !!shopId && !!productId && !!currentVariantId && !!reason,
    staleTime: 5 * 60 * 1000,
  });
}
